<template>
  <div>
    <div class="problem">
      <span>{{ seq }}</span>
      <span>{{ name }}</span>
      <span>{{ type | formatType }}</span>
    </div>
    <div class="options" v-if="options.length > 0">
      <!--
             1-单选 2-多选 3-问答 4.多选混合问答
      -->
      <div v-if="type === '1'">
        <van-radio-group
          v-model="answer.optionId"
          class="option-line"
          @change="checkOptions"
        >
          <van-radio
            :name="option.id"
            v-for="option in options"
            :key="option.id"
            checked-color="#e10913"
            class="option-item"
            >{{ option.name }}</van-radio
          >
        </van-radio-group>
      </div>
      <div v-if="type === '2'">
        <van-checkbox-group v-model="answer.optionId" @change="checkOptions">
          <div v-for="option in options" :key="option.id" class="option-line">
            <van-checkbox
              :name="option.id"
              checked-color="#e10913"
              class="option-item"
              >{{ option.name }}</van-checkbox
            >
          </div>
        </van-checkbox-group>
      </div>
      <div v-if="type === '3'">
        <div>
          <input
            v-if="options[0].isContent === 1"
            type="text"
            v-model="options[0].optionContent"
            class="multiple-input"
          />
          <textarea
            v-if="options[0].isContent === 2"
            type="text"
            v-model="options[0].optionContent"
            class="multiple-textarea"
          />
        </div>
      </div>
      <div v-if="type === '4'">
        <van-checkbox-group
          v-model="answer.optionId"
          class="option-line"
          @change="checkOptions"
        >
          <div
            v-for="(option, index) in options"
            :key="option.id"
            class="option-item"
          >
            <div class="multiple-input-line">
              <van-checkbox
                :name="option.id"
                checked-color="#e10913"
                ref="checkboxes"
              >
                {{ option.name }}
              </van-checkbox>
              <input
                v-if="option.isContent === 1"
                type="text"
                v-model="options[index].optionContent"
                class="multiple-input"
                @click="toggle(index)"
              />
            </div>
            <textarea
              v-if="option.isContent === 2"
              type="text"
              v-model="options[index].optionContent"
              class="multiple-textarea"
              @click="toggle(index)"
            />
          </div>
        </van-checkbox-group>
      </div>
    </div>
  </div>
</template>
  <script lang="js">
    export default {
        props:{
            problem: {
                type: Object,
                default: {
                    name: '',
                    options: []
                }
            },
            seq:{
                type: String,
                default: '1/1.'
            }
        },
        watch:{
            problem(newVal, oldVal){
                if(!newVal){
                    this.name = '';
                    this.options = []
                    this.type = null
                    this.answer = {}
                    return
                }
                this.name = newVal.name
                this.options = [...newVal.options]
                this.type = newVal.type
                this.answer = {...newVal.answer} || {}
                if(this.type === 3){
                    this.answer.optionId = newVal.options[0].id
                }
            }
        },
        data(){
            return {
                name: '',
                options: [],    
                type: null,
                answer: {}            
            }
        },
        filters:{
            formatType : function (vaule){
               switch(vaule){
                case '1':
                    return '(单选)'
                case '2':
                    return '(多选)'
                case '3':
                    return '(问答)'       
                case '4':
                    return '(多选)' 
                default:
                    return ''             
               }
            }
        },
        created(){
    
        },
        mounted(){
    
        },
        methods: {
            checkOptions(){
                let p = {
                    answer: {...this.answer},
                    options: [...this.options]
                }
                this.$emit("change", p)                
            },
            toggle(index) {
                let current = this.options[index].id;
                if(Array.isArray(this.answer.optionId) && this.answer.optionId.some(o => o === current)){
                    //已勾选 需点击checkbox 反选
                    return;
                }
                this.$refs.checkboxes[index].toggle();
            },
        }
    }
  </script>    
  <style scoped lang="less" rel="stylesheet/less">
.problem {
  font-size: 18px;
}
.options {
  font-size: 16px;
  max-height: calc(100vh - 3.6rem - 110px);
  overflow: auto;
}
.option-line {
  display: flex;
  flex-direction: column;
}
.multiple-input-line {
  display: flex;
  flex-direction: row;
}
.option-item {
  margin: 0.2rem 0.2rem;
}
.multiple-input {
  background: #f6f6f6;
  border-top: none;
  border-left: none;
  border-right: none;
  width: 50%;
  border-width: 1px;
}
.multiple-textarea {
  background: #f6f6f6;
  margin-top: 0.2rem;
  margin-left: 0.2rem;
  width: 7.5rem;
  height: 2rem;
}
</style>
    


// WEBPACK FOOTER //
// src/components/client/childCompoents/surveyProblem.vue